module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    class: _vm.cssClass
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/abuild/rpmbuild/BUILD/Portus-master/~/vue-loader/lib/template-compiler?{"id":"data-v-9892f2a0"}!/home/abuild/rpmbuild/BUILD/Portus-master/~/vue-loader/lib/selector.js?type=template&index=0!./shared/components/loading-icon.vue
// module id = 86
// module chunks = 0